export enum RequestModuleEnum {
  User = 'user',
  UserEmail = 'user_email',
  Tags = 'tags',
  Students = 'students',
  TagsStatistics = 'tags_statistics',
  TagsCounter = 'tags_counter',
  TagsListing = 'tags_listing',
  EmailDeliveryStatistics = 'email_delivery_statistics',
  EmailDeliveryStatisticsChart = 'email_delivery_statistics_chart',
  EmailDeliveryStatisticsUser = 'email_delivery_statistics_user',
  EmailDeliveryStatisticsEmail = 'email_delivery_statistics_email',
  MembershipCourse = 'membership_course',
  MembershipCourseCurriculum = 'membership_course_curriculum',
  MembershipLightCourse = 'membership_light_course',
  MembershipLightCourseCurriculum = 'membership_light_course_curriculum',
  MembershipCourseLecture = 'membership_course_lecture',
  CourseBundle = 'course_bundle',
  SubAccounts = 'sub_accounts',
  SubAccountsListing = 'sub_accounts_listing',
  SubAccountsCounters = 'sub_accounts_counters',
  SubAccountsResources = 'sub_accounts_resources',
  SubAccountsSales = 'sub_accounts_sales',
  SubAccountsNewLeads = 'sub_accounts_new_leads',
  GoogleIntegrations = 'google_integrations',
  GoogleIntegrationsCalendars = 'google_integrations_calendars',
  Community = 'community',
  Websites = 'websites',
  WebsiteTemplates = 'website_templates',
  UserDomainsWithWebsite = 'user_domains_with_website',
  TwilioIntegration = 'twilio_integration',
  TwilioPhoneNumbers = 'twilio_phone_numbers',
  TwilioMessageServices = 'twilio_message_services',
  SmsTemplates = 'sms_templates',
  Assignments = 'assignments',
  Contacts = 'contacts',
  WhiteLabel = 'white_label',
  WhiteLabelUsers = 'white_label_users',
  WhiteLabelUserPlan = 'white_label_user_plan',
  Campaign = 'campaign',
  CampaignStep = 'campaign_step',
  AutomationRule = 'automation_rule',
  Calendar = 'calendar',
  CalendarBookings = 'calendar_bookings',
  AvailabilityBookings = 'calendar_availability',
  Notifications = 'notifications',
  CustomDomains = 'custom_domains',
  PhysicalProducts = 'physical_products',
  Newsletters = 'newsletters',
  Funnels = 'funnels',
  FunnelsStep = 'funnels_step',
}
